import dynamic                        from "next/dynamic";
import { useRouter }                  from "next/router";
import React, { useEffect, useState } from "react";
import useSWRInfinite                 from "swr/infinite";

import { useGetDeviceType } from "_common/hooks/global";
import FetchMore            from "_components/atoms/fetchMoreLoader";
import useDfpSlot           from "_components/features/ads/useDfpSlot";
import { getResults }       from "_components/pages/game/cardListData/container";
import useStyles            from "_components/pages/home/desktop/categoryPage/styles";
import remoteConfigInstance from "_services/firebase/fetchRemoteConfig";

const GamingZone    = dynamic ( () => import ( "./gamingZone" ) );
const GamingVideos  = dynamic ( () => import ( "./gamingVideos" ) );
const PopupAd       = dynamic ( () => import ( "./ads/popup-no-carousel" ) );
const PopupVideo    = dynamic ( () => import ( "./ads/popup-video" ) );
const LeaderboardAd = dynamic ( () => import ( "./ads/leaderboard" ) );
const StickyAd      = dynamic ( () => import ( "./ads/sticky" ) );

function Page ( props ) {
	const _list = props?.feedList;

	// SWR API CALL
	const router                         = useRouter ();
	const { data, error, size, setSize } = useSWRInfinite (
		index => {
			return { key: "videos", pageNo: index + 2, searchQuery: props.name, gameId: props.gameId, androidPackageName: props.androidPackageName };
		},
		getResults,
		{ fallbackData: [], revalidateFirstPage: false }
	);

	const isLoadingInitialData = !data && !error;
	const isDepleted           = data?.[size - 1]?.length === 0;
	const isLoading            = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );

	// Step 1
	const feedList = [].concat.apply ( [], data );

	const list        = [ ..._list, ...feedList ];
	const deviceType  = useGetDeviceType ();
	const isMobile    = deviceType === "mobile";
	const { classes } = useStyles ( { isMobile }, { name: "gamingVideos" } );

	const fetchMore                       = () => {
		setSize ( size + 1 );
	};
	const [ gameZopData, setGameZopData ] = useState ( {} );
	const fetchGamezopLinks               = async () => {
		const links = await remoteConfigInstance.getData ( "sportx", "Gaming_videos_games_config" );

		setGameZopData ( links );
	};

	useEffect ( () => {
		fetchGamezopLinks ();
	}, [] );

	return (
		<div className = { classes.container }>

			{props?.popupVideo ? <PopupVideo /> : <PopupAd />}

			{isMobile ? (
				<FirstAdMweb />
			) : null}

			<GamingZone
				classes         = { classes }
				data            = { gameZopData }
				onClickViewMore = { () => {
					window.open ( gameZopData?.all_game_url );
				} }
			/>

			{isMobile ? null : (
				<LeaderboardAd />
			)}

			{isMobile ? (
				<StickyAd />
			) : null}

			{/* <GamingNews
				classes = { classes }
				isMobile = { isMobile }
				onClickViewMore = { () => {} }
			/>*/}

			<GamingVideos
				classes         = { classes }
				isMobile        = { isMobile }
				list            = { list }
				onClickViewMore = { () => {
					router.push ( "/game/2052989/gaming-world?tab=videos" );
				} }
			/>

			<FetchMore
				fetchMore  = { fetchMore }
				isDepleted = { isDepleted }
				isLoading  = { isLoading }
			/>

		</div>
	);
}

const FirstAdMweb = () => {
	const MWEB_Ad_UNIT = "/22991961619/home_feed_ad_mweb_1_300x250";

	const comp = useDfpSlot ( {
		path : MWEB_Ad_UNIT,
		size : [ 300, 250 ],
		id   : "gpt-passback-first"
	} );

	return comp;
};

export default Page;
